// src/routes/ProjectDetail.jsx

import React from "react";
import { useParams } from "react-router-dom";
import ZenProjects from "../data/zencode";
import ReactMarkdown from "react-markdown";

import SectionZen from "../components/SectionZen.jsx";
import remarkGfm from "remark-gfm";
import { Helmet } from "react-helmet";
import ProjectCard from "../kits/LayoutKit/ProjectCard";
import PaperBG from "../kits/DesignKit/PaperBG";



const ProjectDetail = () => {
  const { slug } = useParams();
  const project = ZenProjects.find((p) => p.slug === slug);

  if (!project) return <div>Projekt nicht gefunden.</div>;

  return (
    <PaperBG>

    <div className="max-w-3xl mx-auto p-6">
      <Helmet>
        <title>{project.title} – ZenCode</title>
        <meta name="description" content={project.description} />
      </Helmet>

<>

      {project.cover && (
        <img src={project.cover} alt={project.title} className="mb-6 rounded-xl" />
      )}

      <h1 className="text-3xl font-bold mb-4">{project.title}</h1>
      <div className="prose prose-sm text-gray-800">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {project.content}
        </ReactMarkdown>
      </div>

      <div className="mt-16">
      < SectionZen ></SectionZen>
        <h2 className="text-sm bg-orange-300 border-gray-800 rounded-sm font-bold font-mono mb-4 text-center">Weitere Projekte</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {ZenProjects.filter(p => p.slug !== slug).map((p) => (
            <ProjectCard
              icon={project.icon}
              key={p.slug}
              
              title= {p.title}
              description={p.description}
            
              href={`/zencode/${p.slug}`}
            />
          ))}
        </div>
      </div>

      </>
    </div>
    </PaperBG>

  );
};


export default ProjectDetail;
